import { useEffect, useState } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "src/@/components/ui/card";
import { Button } from "src/@/components/ui/button";
import CardActionEntrarFase from "src/sections/@dashboard/automacoes/action/CardActionEntrarFase";
import Iconify from "src/components/Iconify"; // Iconify for icons
import { Input } from "src/@/components/ui/input";
import HttpRequestComponent from "src/sections/@dashboard/automacoes/reaction/HttpRequestComponent";
import CardReactionMoverCardFunil from "src/sections/@dashboard/automacoes/reaction/CardReactionMoverCardFunil";
import CardActionCampoAtualizado from "src/sections/@dashboard/automacoes/action/CardActionCampoAtualizado";
import { useNavigate, useParams } from "react-router";
import v2_actionAutomacao from "src/actions/v2/automacoes/v2_actionAutomacao";
import { Switch } from "src/@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/@/components/ui/select";
import ChatAddNoteComponent from "src/sections/@dashboard/automacoes/reaction/ChatAddNoteComponent";
import CardSendMessage from "src/sections/@dashboard/automacoes/reaction/CardSendMessage";
import CardTransferCard from "src/sections/@dashboard/automacoes/reaction/CardTransferCard";
import useAuth from "src/hooks/useAuth";
import ChatAddTag from "src/sections/@dashboard/automacoes/reaction/ChatAddTag";
import CardNewLead from "src/sections/@dashboard/automacoes/reaction/CardNewLead";
import CardChangeValue from "src/sections/@dashboard/automacoes/reaction/CardChangeValue";
import ChatKeywordFilter from "src/sections/@dashboard/automacoes/action/ChatKeywordFilter";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import CardActionSairEstagio from "src/sections/@dashboard/automacoes/action/CardActionSairEstagio";
import ChatAccept from "src/sections/@dashboard/automacoes/action/ChatAccept";
import ChatAssign from "src/sections/@dashboard/automacoes/action/ChatAssign";
import { v4 as uuidv4 } from 'uuid';
import { DialogLogsAutomacao } from "src/sections/@dashboard/automacoes/DialogLogsAutomacao";
import v2_actionEditarAutomacao from "src/actions/v2/automacoes/v2_actionEditarAutomacao";
import { useToast } from "src/@/components/ui/use-toast";
import { enqueueSnackbar, useSnackbar } from "notistack";
import SkeletonAutomation from "src/components/skeleton/automacoes/SkeletonAutomation";


const Connector = () => {
  return (
    <div className="relative flex items-center justify-center w-16 h-8 -mx-2">
      {/* Line */}
      <div className="absolute w-full h-0.5 bg-violet-200"></div>
      {/* First Circle */}
      <div className="absolute left-0 w-3 h-3 bg-violet-500 rounded-full"></div>
      {/* Second Circle */}
      <div className="absolute right-0 w-3 h-3 bg-gray-300 rounded-full"></div>
    </div>
  );
}

export default function Automacao() {
  const { id } = useParams();
  const {enqueueSnackbar} = useSnackbar();
  const { user, cliente } = useAuth();
  const navigate = useNavigate()
  const [actionPhase, setActionPhase] = useState(null);
  const [reactionPhase, setReactionPhase] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [automacao, setAutomacao] = useState(null);
  const [editEvent, setEditEvent] = useState(true);
  const [loading, setLoading] = useState(false);

  const [actionState, setActionState] = useState({
    pipelineId: null,
    stageId: null,
    valuesFields: [],
    chatUsersAccept: [],
    chatKeywords: []
  });



  function verifyAccepts(action, event) {
    if (!event) return false;
    return action.accepts?.includes(event.value);
  }

  const automationEvents = [
    {
      name: "Um campo for atualizado",
      value: "from.funnel.card.field.change",
      category: "funil",
      icon: "mdi:pencil-outline", // Iconify icon
    },
    {
      name: "Um card for criado",
      value: "from.funnel.card.create",
      category: "funil",
      icon: "mdi:plus-box-outline", // Iconify icon
    },
    {
      name: "Um card sair de um estágio",
      value: "from.funnel.card.out.stage",
      category: "funil",
      icon: "mdi:swap-horizontal-bold", // Iconify icon
    },
    {
      name: "Um card entrar em um estágio",
      value: "from.funnel.card.in.stage",
      category: "funil",
      icon: "mdi:swap-horizontal-bold", // Iconify icon
    },
    // {
    //   name: "Inatividade em um funil/estágio",
    //   value: "inatividade_card_funil",
    //   category: "rotina",
    //   icon: "mdi:swap-horizontal-bold", // Iconify icon
    // },
    {
      name: "Um usuario aceitou um chat pendente",
      value: "from.chat.accept",
      category: "chat",
      icon: "mdi:account-check-outline", // Iconify icon
    },
    {
      name: "Uma mensagem de um chat conter uma palavra-chave",
      value: "from.chat.contains",
      category: "chat",
      icon: "mdi:message-text-outline", // Iconify icon
    },
    {
      name: "Um chat for direcionado",
      value: "from.chat.assign",
      category: "chat",
      icon: "mdi:arrow-right-outline", // Iconify icon
    },
    {
      name: "Um contato fazer aniversário",
      value: "from.jobs.birthdate",
      category: "jobs",
      icon: "mdi:arrow-right-outline", // Iconify icon
    },
    {
      name: "Inatividade em um chat",
      value: "from.jobs.chat.inactivity",
      category: "jobs",
      icon: "mdi:arrow-right-outline", // Iconify icon
    },
  ];

  const automationActions = [
    {
      name: "Mova um card para um funil/estágio",
      value: "mover_card_funil",
      icon: "mdi:move-resize",
      category: "funil",
      accepts: ["from.funnel.card.field.change", "chat_palavra_chave", "from.funnel.card.create", "from.funnel.card.out.stage", "from.funnel.card.in.stage", "inatividade_card_funil", "chat_aceito", "from.chat.assign", "from.chat.contains"],
    },
    {
      name: "Faça uma ação no Lead",
      value: "to.funnel.action",
      icon: "mdi:form-textbox",
      category: "funil",
      accepts: ["from.funnel.card.field.change", "chat_palavra_chave", "from.funnel.card.create", "from.funnel.card.out.stage", "from.funnel.card.in.stage", "inatividade_card_funil", "chat_aceito", "from.chat.assign", "from.chat.contains"],
    },
    {
      name: "Criar uma nota no chat",
      value: "to.chat.addNote",
      icon: "mdi:note-text-outline",
      category: "chat",
      accepts: ["from.funnel.card.field.change", "chat_palavra_chave", "from.funnel.card.create", "from.funnel.card.out.stage", "from.funnel.card.in.stage", "inatividade_card_funil", "chat_aceito", "from.chat.assign", "from.chat.contains"],
    },
    {
      name: "Crie um card",
      value: "to.funnel.cardCreate",
      icon: "mdi:card-outline",
      category: "funil",
      accepts: ["from.funnel.card.field.change", "chat_palavra_chave", "from.funnel.card.create", "from.funnel.card.out.stage", "from.funnel.card.in.stage", "inatividade_card_funil", "chat_aceito", "from.chat.assign", "from.chat.contains"],
    },
    {
      name: "Adicionar Etiqueta ao chat",
      value: "to.chat.addTag",
      icon: "mdi:tag-outline",
      category: "chat",
      accepts: ["from.funnel.card.field.change", "chat_palavra_chave", "from.funnel.card.create", "from.funnel.card.out.stage", "from.funnel.card.in.stage", "inatividade_card_funil", "chat_aceito", "from.chat.assign", "from.chat.contains"],
      alerts: [
        "Caso não tenha um chat vinculado, esta ação será ignorada."
      ]
    },
    {
      name: "Enviar uma mensagem no chat",
      value: "to.chat.sendMessage",
      icon: "mdi:tag-outline",
      category: "chat",
      accepts: ["from.jobs.birthdate", "from.funnel.card.field.change", "chat_palavra_chave", "from.funnel.card.create", "from.funnel.card.out.stage", "from.funnel.card.in.stage", "inatividade_card_funil", "chat_aceito", "from.chat.assign", "from.chat.contains"],
      alerts: [
        "Caso não tenha um chat vinculado ao lead, esta ação será ignorada."
      ]
    },
    {
      name: "Transferir um card para um usuário",
      value: "to.funnel.cardTransferUser",
      icon: "mdi:account-switch-outline",
      category: "funil",
      accepts: ["from.funnel.card.field.change", "chat_palavra_chave", "from.funnel.card.create", "from.funnel.card.out.stage", "from.funnel.card.in.stage", "inatividade_card_funil", "chat_aceito", "from.chat.assign", "from.chat.contains"],
      alerts: [

      ]
    },
    {
      name: "Uma requisição HTTP",
      value: "to.httpRequest",
      icon: "mdi:web",
      category: "funções",
      accepts: ["from.funnel.card.field.change", "chat_palavra_chave", "from.funnel.card.create", "from.funnel.card.out.stage", "from.funnel.card.in.stage", "inatividade_card_funil", "chat_aceito", "from.chat.assign", "from.chat.contains"],
    },
    {
      name: "Enviar para Make",
      value: "to.make",
      icon: "simple-icons:make",
      category: "funções",
      accepts: ["from.funnel.card.field.change", "chat_palavra_chave", "from.funnel.card.create", "from.funnel.card.out.stage", "from.funnel.card.in.stage", "inatividade_card_funil", "chat_aceito", "from.chat.assign", "from.chat.contains"],
    },
  ];

  const filteredActions = automationActions.filter(action => action.accepts.includes(actionPhase?.value));




  useEffect(() => {
    const fetchAutomation = async () => {
      try {
        setLoading(true);
        const response = await v2_actionAutomacao(id);
        const automacaoData = response.data.data;

        // Atualize os blocos com os valores obtidos
        if (automacaoData?.params?.to) {
          const mappedBlocks = automacaoData.params.to.map(block => ({
            id: uuidv4(), // ou use um ID único fornecido pela API
            value: block.value,
            data: block.data
          }));
          setBlocks(mappedBlocks);
        }

        // Preencha outros estados, se necessário
        if (automacaoData?.params?.from) {
          const action = automationEvents.find(event => event.value === automacaoData.params.from.action);
          setActionPhase(action);
          setSelectedEvent(action);
          setActionState({
            pipelineId: automacaoData.params.from.pipeline_id,
            stageId: automacaoData.params.from.stage_id[0],
            valuesFields: automacaoData.params.from.values,
            chatUsersAccept: automacaoData.params.from.chatUsersAccpet,
            chatKeywords: automacaoData.params.from.chatKeywords
          });
        }


        // Atualize o estado geral de automação
        setAutomacao(automacaoData);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Erro ao carregar automação:", error);
      }
    };

    if (id) {
      fetchAutomation();
    }
  }, [id]); // Certifique-se de que a dependência está correta

  const groupedEvents = automationEvents.reduce((groups, event) => {
    const category = event.category;
    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(event);
    return groups;
  }, {});

  const [blocks, setBlocks] = useState([]);

  // Função para adicionar um novo bloco
  const addBlock = () => {
    setBlocks((prevBlocks) => [
      ...prevBlocks,
      {
        id: uuidv4(),
        value: null,
        data: null
      },
    ]);
  };
  // Função para remover um bloco
  const removeBlock = (id) => {
    setBlocks(blocks.filter((block) => block.id !== id));
  };

  // Função para atualizar o tipo do bloco
  const updateBlockType = (id, value) => {
    setBlocks(
      blocks.map((block) => (block.id === id ? { ...block, value } : block))
    );
  };




  const handleChangeAction = (event) => {
    if (event.name === "pipeline_id") {
      setActionState({ ...actionState, pipelineId: event.value });
    } else if (event.name === "stage_id") {
      setActionState({ ...actionState, stageId: event.value });
    } else if (event.name === "valuesFields") {
      setActionState({ ...actionState, valuesFields: event.value });
    } else if (event.name === "chatUsersAccept") {
      setActionState({ ...actionState, chatUsersAccept: event.value });
    } else if (event.name === "chatKeywords") {
      setActionState({ ...actionState, chatKeywords: event.value });
    }
  }

  const handleChangeBlock = (id, event) => {
    console.log("Evento", id, event);
    if (event.name === "chatFiles") {
      setBlocks((prevBlocks) =>
        prevBlocks.map((block) => {
          if (block.id === id) {
            let updatedChatFiles;
            if (event.action === "delete") {
              // Filtra os arquivos para remover o arquivo especificado
              updatedChatFiles = event.value;
            } else {
              // Adiciona novos arquivos
              updatedChatFiles = [
                ...(block.data?.chatFiles || []),
                ...(Array.isArray(event.value) ? event.value : [event.value])
              ];
            }
            return {
              ...block,
              data: {
                ...block.data,
                [event.name]: updatedChatFiles
              }
            };
          }
          return block;
        })
      );
      return;
    }
    setBlocks((prevBlocks) =>
      prevBlocks.map((block) =>
        block.id === id
          ? { ...block, data: { ...block.data, [event.name]: event.value } }
          : block
      )
    );
};
  

  const handleEditAutomation = async () => {
    let data = {
      scope: {
        status: automacao.status,
        params: {
          from: {
            action: actionPhase.value,
            pipeline_id: actionState.pipelineId,
            stage_id: [actionState.stageId],
            values: actionState.valuesFields,
            chatUsersAccpet: actionState.chatUsersAccept,
            chatKeywords: actionState.chatKeywords,
          },
          to: blocks
        }
      }

    }
    await v2_actionEditarAutomacao(id, data);
    enqueueSnackbar("Automação editada com sucesso!", {variant: "success"});
 
    console.log("Editando automação", data)
  }

  return (
    <div className="bg-slate-100">
      <div className="container mx-auto p-8">

        <div className="py-4 flex justify-between">
          <div className="w-full flex flex-col">
            <div className=" flex flex-row gap-4 items-center">
              <Button
                variant="outline"
                onClick={() =>
                  navigate(-1)
                }
              >
                <Iconify icon="mdi:arrow-left" className="mr-2" />
                automações
              </Button>
              <div>
                <Input
                  value={automacao?.name}
                  onChange={(e) => {
                    setAutomacao({ ...automacao, name: e.target.value });
                    setEditEvent(true);
                  }}
                  placeholder="Nome da automação"
                  className="w-[400px] bg-white h-10"
                />
              </div>
              <Switch
                checked={automacao?.status}
                onClick={(event) => {
                  event.stopPropagation();
                  setAutomacao({ ...automacao, status: !automacao.status });
                }}
              />
            </div>

          </div>

          <div className="flex flex-row gap-2">
            <Button
              size="icon"
              variant="outline"
            >
              <Iconify className="text-red-600" icon="mdi:delete-outline" />
            </Button>
            <DialogLogsAutomacao
              user={user}
            />
            {editEvent && (
              <Button

                className="bg-violet-500"
                onClick={handleEditAutomation}
              >
                <Iconify icon="mdi:content-save" className="mr-2" />
                Salvar
              </Button>
            )}

          </div>
        </div>

        {
          loading ? (
            <SkeletonAutomation />
          ) : (
            <div className="flex mt-4">
            {/* Left column (Event triggers) */}
            <div className="min-w-[450px]">
              <Card className="w-full">
                <CardHeader>
                  <div className="flex justify-between">
                    <CardTitle>Sempre que...</CardTitle>
                    {actionPhase && (
                      <Button onClick={() => {
                        setActionPhase(null);
                        setActionState(
                          {
                            pipelineId: null,
                            stageId: null,
                            valuesFields: [],
                            chatUsersAccept: [],
                            chatKeywords: []
                          }
                        )
                      }} variant="ghost">
                        <Iconify icon="ic:baseline-close" />
                      </Button>
                    )}
                  </div>
                </CardHeader>
                <CardContent>
                  {actionPhase?.value === "from.funnel.card.in.stage" && <CardActionEntrarFase
                    actionPhase={actionPhase}
                    actionState={actionState}
                    changeActionState={handleChangeAction}
                  />}
                  {actionPhase?.value === "from.funnel.card.out.stage" && <CardActionSairEstagio
                    actionPhase={actionPhase}
                    actionState={actionState}
                    changeActionState={handleChangeAction}
                  />}
                  {actionPhase?.value === "from.funnel.card.create" && <div>
                    <LabelFromAction>
                      {actionPhase.name}
                    </LabelFromAction>
                  </div>}

                  {actionPhase?.value === "from.jobs.birthdate" && <div>
                    <LabelFromAction>
                      {actionPhase.name}
                    </LabelFromAction>
                  </div>}

                  {actionPhase?.value === "from.funnel.card.field.change" && <CardActionCampoAtualizado
                    actionState={actionState}
                    changeActionState={handleChangeAction}
                    cliente={cliente}
                    actionPhase={actionPhase}
                  />}
                  {actionPhase?.value === "from.chat.accept" && (
                    <ChatAccept
                      actionPhase={actionPhase}
                      user={user}
                      changeActionState={handleChangeAction}
                      actionState={actionState}
                    />
                  )}
                  {actionPhase?.value === "from.chat.assign" && (
                    <ChatAssign
                      actionPhase={actionPhase}
                      user={user}
                      changeActionState={handleChangeAction}
                      actionState={actionState}
                    />
                  )
                  }
                  {actionPhase?.value === "from.chat.contains" && <ChatKeywordFilter
                    actionPhase={actionPhase}
                    actionState={actionState}
                    changeActionState={handleChangeAction}
                  />}
  
                  {!actionPhase && (
                    <div className="space-y-4">
                      {Object.keys(groupedEvents).map((category, index) => (
                        <div key={index}>
                          <h3 className="font-semibold text-gray-700 capitalize mb-2">{category}</h3>
                          <ul className="space-y-2">
                            {groupedEvents[category].map((event, index) => (
                              <li key={index}>
                                <Button
                                  variant={selectedEvent === event ? "default" : "outline"}
                                  onClick={() => {
                                    setActionPhase(event);
                                    setSelectedEvent(event);
                                  }}
                                  className="flex items-center space-x-2"
                                >
                                  <Iconify icon={event.icon} />
                                  <span className="text-xs">{event.name}</span>
                                </Button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  )}
                </CardContent>
              </Card>
            </div>
  
  
            <Connector />
            {/* Right column (Actions) */}
            <div className="w-full">
  
              <Card>
                <CardHeader>
                  <div className="flex justify-between gap-2">
                    <CardTitle>Faça isso...</CardTitle>
                    {reactionPhase && (
                      <Button onClick={() => setReactionPhase(null)} className="bg-red-200">
                        <Iconify icon="ic:baseline-close" />
                      </Button>
                    )}
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="py-4 bg-slate-100">
                    <div className="container mx-auto">
                      {/* Renderizar Blocos */}
                      {blocks.map((block, index) => (
                        <div key={block.id} className="relative">
                          {/* Bloco Individual */}
                          <Card>
                            <CardHeader>
                              <div className="flex justify-between gap-2">
                                <Select
                                className="bg-slate-500" 
                                  onValueChange={(value) => updateBlockType(block.id, value)}
                                  value={block.value}
                                >
                                  <SelectTrigger className="w-full">
                                    <SelectValue placeholder="Selecione uma ação" />
                                  </SelectTrigger>
                                  <SelectContent>
                                    {filteredActions.map((action) => (
                                      <SelectItem key={action.value} value={action.value}>
                                        <div className="flex flex-row gap-1">
                                        <Iconify icon={action.icon} className="mr-2" />
                                        {action.name}
                                        </div>
                                  
                                      </SelectItem>
                                    ))}
                                  </SelectContent>
                                </Select>
                                <Button
                                  variant="ghost"
                                  className="bg-red-100"
                                  onClick={() => removeBlock(block.id)}
                                >
                                  <Iconify icon="mdi:delete-outline" />
                                </Button>
                              </div>
                            </CardHeader>
                            <CardContent>
                              {/* Seleção do tipo de bloco */}
                              <div className="">
                                {block.value === "to.funnel.cardTransferUser" && (
                                  <CardTransferCard
                                    user={user}
                                    block={block}
                                    changeBlock={(event) => handleChangeBlock(block.id, event)}
                                    cardId={block.data.cardId}
                                    availableUsers={[]}
                                    onCardTransferred={block.data.onCardTransferred}
                                  />
                                )}
                                {block.value === "to.chat.addNote" && (
                                  <ChatAddNoteComponent
                                    block={block}
                                    changeBlock={(event) => handleChangeBlock(block.id, event)}
                                  />
                                )}
                                {
                                  block.value === "to.httpRequest" && (
                                    <HttpRequestComponent
                                      block={block}
                                      changeBlock={(event) => handleChangeBlock(block.id, event)}
                                    />
                                  )}
                                {block.value === "to.chat.sendMessage" && (
                                  <CardSendMessage
                                    block={block}
                                    changeBlock={(event) => handleChangeBlock(block.id, event)}
                                  />
                                )}
                                {block.value === "to.chat.addTag" && (
                                  <ChatAddTag
                                    block={block}
                                    changeBlock={(event) => handleChangeBlock(block.id, event)}
                                  />
                                )}
                                {block.value === "to.funnel.cardCreate" && (
                                  <CardNewLead
                                    block={block}
                                    changeBlock={(event) => handleChangeBlock(block.id, event)}
                                  />
                                )}
                                {block.value === "mover_card_funil" && (
                                  <CardReactionMoverCardFunil
                                    block={block}
                                    changeBlock={(event) => handleChangeBlock(block.id, event)}
                                  />
                                )}
                                {
                                  block.value === "to.funnel.action" && (
                                    <CardChangeValue
                                      block={block}
                                      changeBlock={(event) => handleChangeBlock(block.id, event)}
                                    />
                                  )
                                }
  
                              </div>
                            </CardContent>
                          </Card>
  
                          {/* Conector entre os blocos */}
                          {index < blocks.length - 1 && (
                            <div className="flex justify-center items-center">
                              <div className="relative w-2 h-12 flex justify-center">
                                {/* Linha vertical */}
                                <div className="absolute w-0.5 bg-gray-300 h-full"></div>
                                {/* Círculo no centro */}
                                <div className="absolute w-3 h-3 bg-violet-500 rounded-full top-1/2 -translate-y-1/2"></div>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
  
                      {/* Botão para adicionar mais blocos */}
                      {
                        actionPhase && (
                          <div className="flex justify-center mt-4">
                            <Button variant="outline" onClick={addBlock} className="flex items-center">
                              <Iconify icon="mdi:plus-circle-outline" className="mr-2" />
                              Adicionar Ação
                            </Button>
                          </div>
                        )
                      }
  
                    </div>
                  </div>
                </CardContent>
  
              </Card>
            </div>
          </div>
          )
        }


      </div>
    </div>
  );
}